module.exports = __webpack_public_path__ + "static/media/user-icon-5.842e5f3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/user-icon-5.png
// module id = 326
// module chunks = 0